export const IFRAME_ACTION_PERSIST = "IFRAME_PERSIST";
export const IFRAME_ACTION_CLEAR = "IFRAME_CLEAR";
